// @flow

import type { Action } from './store.type';

export const UPLOAD_FILES_REQUEST = 'UPLOAD_FILES_REQUEST';
type UPLOAD_FILES_REQUEST_TYPE = 'UPLOAD_FILES_REQUEST';

export const UPLOAD_FILES_SUCCESS = 'UPLOAD_FILES_SUCCESS';
type UPLOAD_FILES_SUCCESS_TYPE = 'UPLOAD_FILES_SUCCESS';

export const UPLOAD_FILES_FAILURE = 'UPLOAD_FILES_FAILURE';
type UPLOAD_FILES_FAILURE_TYPE = 'UPLOAD_FILES_FAILURE';

type FilesSuccess = {
  data: Object
};

type FilesFailure = {
  error: any
};

type FilesRequestAction = Action<UPLOAD_FILES_REQUEST_TYPE, null>;

type FilesSuccessAction = Action<UPLOAD_FILES_SUCCESS_TYPE, FilesSuccess>;

type FilesFailureAction = Action<UPLOAD_FILES_FAILURE_TYPE, FilesFailure>;

export type FilesAction = FilesRequestAction | FilesSuccessAction | FilesFailureAction;

export type FilesState = {
  filesLoading: boolean,
  filesSuccess: boolean,
  error: any
};
